import productObject from './productObject';

export default {
  template: '#default_product_selection_list',
  components: {
    productObject,
  },
  props: ['categories', 'currentCategory'],
  data: function() {
    return {
      activeCategory: null,
      activeProducts: [],
      mock_index: -1,
      mock_id: -1,
      current_view: 'CATEGORY',
      product_info: {
        product_obj: null,
        product_name: '',
        current_side: 'FRONT',
        colors: [],
        sizes: [],
        description: '',
        front_image: '',
        back_image: '',
        front_thumbnail: '',
        back_thumbnail: ''
      },
      sizeType: 'I',
      measurementType: 'LENGTH',
      modal_title: 'Choose a Product Category',
      promo_category: [],
      promo_text_category: 'PROMO',
      new_product_category: ['ALL OVER PRINT'],
      new_product_category_badge_text: 'NEW PRODUCT',
    };
  },
  computed: {
    showSizes() {
      return this.product_info.sizes.length > 1;
    },
    showBackView() {

      if(this.product_info.product_obj.back_thumbnail_text == '') {
        return false;
      }

      return this.product_info.product_obj.back_view == 'SHOW';
    },
  },
  ready() {
    $('.current-product-list').mCustomScrollbar({ setHeight: '600px', theme: 'dark-thick' });
  },
  attached: function() {
    this.setProductsFromCategories();
  },
  events: {
    'page-segment-defined': function() {
      this.setProductsFromCategories();
    },
    'open-select-product': function() {
      this.openProductSelectionModal();
    },
    'close-select-product': function() {
      this.closeProductSelectionModal();
    },
    'on-product-show-info': function(product) {
      this.showProductInfo(product);
    }
  },
  methods: {
    openProductSelectionModal() {
      var $productModal = $('#choose_product_modal');

      this.modal_title = 'Choose a Product Category';
      this.current_view = 'CATEGORY';

      $productModal.modal({
        backdrop: 'static',
        keyboard: false,
        show: true
      });
    },
    closeProductSelectionModal() {
      $('#choose_product_modal').modal('hide');
    },
    changePreviewSide(side) {
      this.product_info.current_side = side;
    },
    activateProductCategory: function(category) {
      this.activeCategory = category;
      this.setProductsFromCategories();
      this.gotoSelectedCategory();
      this.$nextTick(function() {
        $('.current-product-list').mCustomScrollbar({ setHeight: '600px', theme: 'dark-thick' });
      });
    },
    isActive: function(category, currentActiveCategory) {
      if (this.activeCategory) {
        return category.id == this.activeCategory.id;
      } else {
        return category.id == currentActiveCategory.id;
      }
    },
    setProductsFromCategories: function() {
      let products = (this.activeCategory) ? this.activeCategory.category_products : this.$root.active_product_category.category_products;
      let filteredProducts = [];

      if (this.activeCategory) {
        if (this.activeCategory.name.toUpperCase() === "DECOR") {
          let canvasProducts = products.filter(function(product) {
            return product.products.product_type === "CANVAS";
          });

          filteredProducts = products.filter(function(product) {
            return product.products.product_type !== "CANVAS";
          });

          let verticalCanvas = this.getDefaultCanvas(canvasProducts, "Canvas - Portrait");
          let horizontalCanvas = this.getDefaultCanvas(canvasProducts, "Canvas - Landscape");
          let squareCanvas = this.getDefaultCanvas(canvasProducts, "Canvas - Square");

          if (verticalCanvas) {
            filteredProducts.push(verticalCanvas);
          }

          if (horizontalCanvas) {
            filteredProducts.push(horizontalCanvas);
          }

          if (squareCanvas) {
            filteredProducts.push(squareCanvas);
          }

        } else {
          filteredProducts = products;
        }

        if (this.isAPIOrder()) {
          filteredProducts = filteredProducts.filter(function(product) {
            return Number(product.products.dtg_drop_is_locked) === 0;
          });
          this.$set('activeProducts', filteredProducts);
        } else {
          this.$set('activeProducts', filteredProducts);
        }
      }
      this.$nextTick(function() {
        $('#product_category_select').selectBoxIt();
      });
    },
    getDefaultCanvas(canvasProducts, canvasStringToSearchAndGetDefault) {
      let verticalCanvas = canvasProducts.filter(function(canvasProduct) {
        return canvasProduct.products.name.indexOf(canvasStringToSearchAndGetDefault) > -1;
      }).sort(function(a, b) {
        return parseFloat(a.products.suggested_price) - parseFloat(b.products.suggested_price);
      });

      if (verticalCanvas.length > 0) {
        verticalCanvas[0].products.name = canvasStringToSearchAndGetDefault;
        return verticalCanvas[0];
      }
    },
    isPhoneCaseGroup: function(product) {
      if (product)
        return product.products.is_phone_case == 1;
    },
    isAPIOrder: function() {
      return this.$root.isAPIOrder();
    },
    getCategoryIcon(category) {
      return category.icon_class;
    },
    onBackButtonClicked() {
      if (this.current_view == 'PRODUCT')
        this.openProductSelectionModal();
      else
        this.gotoSelectedCategory();
    },
    showProductInfo(product) {
      var imagePath = this.$root.getDesignerHelper().imagePath;
      this.product_info.product_obj = product;
      this.product_info.product_name = product.name;
      this.product_info.description = product.description;
      this.product_info.front_image = imagePath + product.front_base;
      this.product_info.front_thumbnail = imagePath + product.front_preview;

      if (product.sku == '3902') {
        // use weight based measurements for dog shirt
        this.measurementType = 'WEIGHT';
        this.sizeType = 'L';
      } else {
        this.measurementType = 'LENGTH';
        this.sizeType = 'I';
      }

      if (product.back_view == 'SHOW') {
        this.product_info.back_image = imagePath + product.back_base;
        this.product_info.back_thumbnail = imagePath + product.back_preview;
      }
      this.product_info.sizes = product.sizes.split(',');
      this.product_info.colors = this.$root.getDesignerHelper().sortColors(product.product_colors);
      this.modal_title = 'Product Info';
      this.current_view = 'PRODUCT-DETAIL';
    },
    gotoSelectedCategory() {
      this.modal_title = 'Choose a Product ';
      this.current_view = 'PRODUCT';
    },
    selectProduct() {
      //this.$dispatch('on-select-product', this.product_info.product_obj);
    },
    showCategories() {
      this.openProductSelectionModal();
    },
    productSizeRows(sizeJson) {
      var sizeObj = JSON.parse(sizeJson);
      if (sizeObj)
        return _.keys(sizeObj);
      return [];
    },
    productSizeLabel(sizeJson, index, key) {
      var self = this;
      var sizeObj = JSON.parse(sizeJson);
      if (sizeObj) {
        var measurements = sizeObj[index];
        if (key === 'size') {
          return measurements[key];
        } else {

          var parts = measurements[key].split(/\ ?-\ ?/);

          parts = parts.map(function(measurementPart, i) {

            if(self.measurementType === 'LENGTH') {
              if (self.sizeType === "I") {
                return measurementPart + "in";
              } else {
                var cm_size = parseFloat(measurementPart) * 2.54;
                return parseInt(cm_size) + "cm";
              }
            }

            if(self.measurementType === 'WEIGHT') {
              if (self.sizeType === "L") {
                return measurementPart + "lbs"
              } else {
                var kg_size = parseFloat(measurementPart) * 0.453592;
                return parseInt(kg_size) + "kg"
              }
            }

          });

          return parts.join(" - ")

        }
      }
      return '';
    },
    productSizeColumns(sizeJson) {
      var sizeObj = JSON.parse(sizeJson);
      if (sizeObj) {
        var measurements = _.keys(sizeObj[0]);
        return _.remove(measurements, function(m) {
          return m != 'size';
        });
      }
      return [];
    },
    getProductSizingImage() {
      if (this.product_info.product_obj) {
        return this.product_info.product_obj.sizing_image;
      }
      return '';
    },
    setSizeType(type) {
      this.$set('sizeType', type);
    },
    isCategoryInPromo($categoryName) {

      if (this.skipCategoryPromoForShopifyApp()) {

        return false;
      }

      return $.inArray($categoryName.toUpperCase(), this.promo_category) > -1;
    },
    skipCategoryPromoForShopifyApp() {

      return this.isAPIOrder();
    },
    doesCategoryHaveNewProducts($categoryName) {
      return $.inArray($categoryName.toUpperCase(), this.new_product_category) > -1;
    },
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/controls/productSelectionModal.js